<template>
  <tree-list-layout
    :header-panel-enable="true"
    :left-panel-enable="true"
    :left-panel-min-width="240"
    :left-panel-max-width="500"
    :right-top-panel-enable="true"
  >
    <template #headerPanel></template>
    <template #leftPanel>
      <!-- tree树搜索 -->
      <el-input
        v-model.trim="treeSearchValue"
        :placeholder="$t('common.search')"
        class="self-filter-input"
        clearable
        @keyup.enter.native="handleSearchTree"
      >
        <i slot="suffix" class="el-input__icon el-icon-search cursor-p" @click="handleSearchTree" />
      </el-input>
      <div class="drag-left-title context_left_title">
        <span class="vertical-bar">{{ $t('user.leftTitle') }}</span>
      </div>
      <!-- tree树 -->
      <el-tree
        ref="tree"
        class="self-tree"
        :props="defaultProps"
        :data="treeData"
        node-key="id"
        :highlight-current="true"
        :default-expanded-keys="defaultShowNodes"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
          <span style="padding-right: 10px">{{ node.label }}</span>
        </span>
      </el-tree>
    </template>
    <!-- <template v-slot:rightTopPanel></template> -->
    <template #rightMiddlePanel>
      <!-- 表格上方内容start -->
      <div class="table-top-content">
        <!-- 标题start -->
        <div class="r-b-title">
          <span class="vertical-bar fn18 fnM">{{ $t('user.rightTitle') }}</span>
        </div>
        <!-- 标题 end -->
        <!-- 搜索框 start-->
        <div class="search" style="height: 50px">
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
            @submit.native.prevent
          >
            <el-form-item>
              <el-input
                v-model="searchForm.value"
                clearable
                style="width: 316px"
                :placeholder="$t('user.searchPlaceHolder')"
                @keyup.enter.native="handleSearch"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search cursor-p"
                  @click="handleSearch"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 搜索框 end-->
      </div>
      <!-- 表格上方内容end -->
      <!-- 表格 start -->
      <div style="height: calc(100% - 56px); width: 100%; position: absolute; top: 56px">
        <general-table
          :code="code"
          :columns="tableHeaders"
          :data="tableData"
          style="padding: 0 20px"
        >
          <template #name="{ item }">
            {{ item.displayName }}
          </template>
          <template #operation="{ scope }">
            <el-button
              type="text"
              class="cursor-p"
              width="200"
              @click="handleAssignRoles(scope.row)"
            >
              {{ $t('user.assignRoles') }}
            </el-button>
          </template>
        </general-table>
      </div>
      <!-- 表格 end -->
    </template>
  </tree-list-layout>
</template>

<script>
import userApi from "@/api/user/user";
import { mapGetters } from "vuex";
import RoleApi from "@/api/role/role";
import { commonFilterNode } from "@/utils";
import TreeListLayout from "@/layout/components/TreeListLayout.vue";
import GeneralTable from "@/components/common/GeneralTable";
export default {
  name: "UserList",
  components: {
    // CellTooltip,
    TreeListLayout,
    GeneralTable
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  data() {
    return {
      tableHeaders: [
        {
          label: this.$t("user.displayName"),
          key: "displayName",
          hidden: false,
          fixed: false
        },
        {
          label: this.$t("user.org"),
          key: "org",
          hidden: false,
          fixed: false
        },
        {
          label: this.$t("user.role"),
          key: "roleName",
          width: "180",
          hidden: false
        },
        {
          label: this.$t("user.cellphone"),
          key: "cellphone",
          width: "180",
          hidden: false
        }
      ],
      treeSearchValue: "",
      tableLoading: false,
      dialogVisible: false,
      loading: false,
      currentNode: {},
      defaultProps: {
        label: "orgName",
        children: "children"
      },
      treeData: [],
      searchForm: {
        value: ""
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      defaultShowNodes: [],
      formData: {
        roles: []
      },
      roleList: [],
      roleId: [],
      code: "user-list"
    };
  },

  created() {
    // 获取组织树
    this.getTree(true);
    this.getRoleList();
  },
  methods: {
    // 获取Tree列表
    getTree(isFirst = false) {
      const parmas = {
        parseToTree: true
      };
      userApi.getOrgList(this.tenantId, parmas).then(res => {
        const { data } = res || {};
        if (data && data.length !== 0) {
          this.treeData = [data];
          if (isFirst) {
            this.currentNode = this.treeData[0];
            this.$nextTick(() => {
              this.defaultShowNodes.push(this.treeData[0].id);
              this.$refs.tree && this.$refs.tree.setCheckedKeys([this.treeData[0].id]);
            });
          }
          this.$nextTick(() => {
            this.$refs.tree && this.$refs.tree.setCurrentKey(this.currentNode.id);
          });
          this.getUserList();
        }
      });
    },
    // 获取用户列表数据
    getUserList() {
      this.tableLoading = true;
      const parmas = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        orgId: this.currentNode.id,
        search: this.searchForm.value
      };
      userApi.getUserList(parmas).then(res => {
        this.tableLoading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },
    // 分配角色按钮触发事件
    handleAssignRoles(row) {
      this.dialogVisible = true;
      this.userId = row.id;
      const roleId = [];
      if (row.roles) {
        row.roles.forEach(item => {
          roleId.push(item.id);
        });
      }
      this.formData.roles = roleId;
    },
    roleChange(item) {
      this.$forceUpdate();
    },
    // 关联角色
    handleConfirm() {
      this.loading = true;
      const parmas = {
        keys: this.formData.roles,
        operation: "REPLACE"
      };
      userApi
        .userAssignRole(this.userId, parmas)
        .then(res => {
          this.dialogVisible = false;
          this.loading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("user.assginSuccess"));
          this.getUserList();
          this.formData = {};
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /** * 查询角色列表*/
    getRoleList() {
      RoleApi.getRoleList().then(res => {
        if (res && res.data && res.data.records) {
          this.roleList = res.data.records;
        }
      });
    },
    // 角色列转换为对应的name
    roleFormatter(row) {
      const { roles } = row;
      let roleName = "";
      if (roles && roles.length) {
        for (let i = 0; i < roles.length; i++) {
          if (i === 0) {
            roleName = roles[i].name;
          } else {
            roleName += `;${roles[i].name}`;
          }
        }
        return roleName;
      }
    },
    // 所属结构列转换为对应的name
    orgFormatter(orgs) {
      let orgName = "";
      if (orgs && orgs.length) {
        for (let i = 0; i < orgs.length; i++) {
          if (i === 0) {
            orgName = orgs[i].name;
          } else {
            orgName += `;${orgs[i].name}`;
          }
        }
        return orgName;
      }
    },
    // 关闭弹框
    dialogClosed() {
      this.dialogVisible = false;
      this.formData = {};
    },
    // 点击组织树节点，查询列表
    handleNodeClick(node) {
      this.currentNode = node;
      this.pagination.pageNum = 1;
      this.pagination.total = 0;
      this.tableData = [];
      this.getUserList();
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentNode.id);
      });
    },

    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getUserList();
    },
    // 查找组织树
    handleSearchTree() {
      this.$refs.tree.filter(this.treeSearchValue);
    },
    handleSearch() {
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.tableData = [];
      this.getUserList();
    },
    handleUpdateList() {
      this.getTree();
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 筛选组织树
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    }
  }
};
</script>

<style scoped lang="scss">
.app-wrap {
  display: flex;
}

.table-top-content {
  padding: 20px;
  background-color: #fff;

  .r-b-title {
    margin-bottom: 16px;
  }
}

.demo-form-inline {
  position: absolute;
  z-index: 1;
}

::v-deep .general_table_wrap .operation_wrap {
  margin-bottom: 20px;
}
</style>
